import { Dialog, DialogContent, Box, Typography, DialogActions, FormHelperText, Button } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setMachineDetailsData } from '../../../redux/machineDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { CustomMultiSelect } from '../../../utils/CustomMultiSelect';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Iconify from '../../Iconify';
import { useCallback } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/machines/modifierStatut.css';

export const ModifierEquipment = ({ modifyEquipment, setModifyEquipment }) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const machineDetailsData = useSelector((state) => state.MachineDetailsData);

    const formik = useFormik({
        initialValues: {
            equipment_machine: machineDetailsData?.equipment_machine?.map(e => ({ value: e.equipment.id, label: e.equipment.name })),
        },
        validationSchema: Yup.object().shape({
            equipment_machine: Yup.array().optional(),
        }),
        onSubmit: async (values) => {
            try {
                const data = {
                    equipments: values.equipment_machine.map(e => e.value),
                };
                const response = await axios.patch(`machine/machine_equipments/${id}`, data);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({ open: true, type: 'Modifier les équipements de la machine' }));
                    dispatch(setMachineDetailsData({ ...machineDetailsData, equipment_machine: response.data.equipment_machine }));
                    setModifyEquipment(false);
                }
            } catch (error) {
                console.error('Error updating machine équipements:', error);
                CustomErrorLogger(error, 'Error updating machine équipements');
            }
        },
    });
    const { handleSubmit, values, setFieldValue, touched, errors } = formik;

    const fetchEquipment = useCallback(async (offset, limit, search) => {
        try {
            const response = await axios.get('equipment/list', {
                params: {
                    offset,
                    limit,
                    filters: { debouncedSearch: search },
                },
            });
            if (response.status === 200 || response.status === 201) {
                return response?.data?.equipments?.map(equipment => ({
                    value: equipment.id,
                    label: equipment.name,
                }));
            }
        } catch (error) {
            console.error('Error fetching equipment:', error);
            CustomErrorLogger(error, "error fetching equipment");
        }
    }, []);

    return (
        <Dialog open={modifyEquipment} fullWidth>
            <Box onClick={() => setModifyEquipment(false)} className='modifierStatut_icon_text'>
                <Typography className='modifierStatut_title'>{t('Modifier les équipements de la machine')}</Typography>
                <Iconify icon={"material-symbols:close"} className='modifierStatut_close_icon' />
            </Box>
            <form onSubmit={handleSubmit}>
                <DialogContent className='modifierStatut_dialog_content'>
                    {values.errMsg && <Typography className='modifierStatut_attention_text'>{values.errMsg}</Typography>}

                    <Box className="modifierStatutDateBox">
                        <FormHelperText id="outlined-weight-helper-text" className="addSiteRelationInputTitle">{t('Équipements')}</FormHelperText>
                        <CustomMultiSelect
                            placeholder='Sélectionnez des équipements'
                            className='addSiteRelation_InputField'
                            required={true}
                            value={values.equipment_machine}
                            fetchFunction={fetchEquipment}
                            backendSearchable={true}
                            onChange={(value) => setFieldValue('equipment_machine', value)}
                            helperText={touched.equipment_machine && errors.equipment_machine}
                            error={touched.equipment_machine && Boolean(errors.equipment_machine)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='modifierStatut_dialog_actions'>
                    <Button className='modifierStatut_button_annuler' onClick={() => setModifyEquipment(false)}>{t('Annuler')}</Button>
                    <Button className='modifierStatut_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};